export default __webpack_public_path__ + "static/media/accepted.5cd137a1.svg";